/**
 * Formats month string (YYYYMM) to readable format (MMM YYYY)
 * @param monthStr - Month string in YYYYMM format (e.g., "202501")
 * @returns Formatted month string (e.g., "Jan 2025")
 */
export const formatMonthHeader = (monthStr: string): string => {
    if (!monthStr || monthStr.length !== 6) return monthStr;

    const year = monthStr.substring(0, 4);
    const month = monthStr.substring(4, 6);

    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const monthIndex = parseInt(month, 10) - 1;
    const monthName = monthNames[monthIndex] || month;

    return `${monthName} ${year}`;
};
